import type { DismissReasonVocabulary } from '@/components/common/review/DismissReasonMenu';
import { type DismissReason, DismissReasons } from '@/components/maintenance/model/planVocabulary';

/**
 * The plan's four, led by "Incorrect".
 *
 * "Incorrect" is what the extraction work needs and the one reason that is nearly useless without a
 * note, so it leads and its note prompt asks the question. "Duplicate" points at entity resolution
 * and is the next most actionable. "Not applicable" is about the house rather than the pipeline, and
 * "Other" is the catch-all, so they trail.
 */
export const PLAN_DISMISS_VOCABULARY: DismissReasonVocabulary<DismissReason> = {
	order: [DismissReasons.Incorrect, DismissReasons.Duplicate, DismissReasons.NotApplicable, DismissReasons.Other],
	labels: {
		[DismissReasons.Duplicate]: 'Duplicate',
		[DismissReasons.NotApplicable]: 'Not applicable',
		[DismissReasons.Incorrect]: 'Incorrect',
		[DismissReasons.Other]: 'Other',
	},
	notePrompts: {
		[DismissReasons.Duplicate]: 'Which task is this a duplicate of?',
		[DismissReasons.NotApplicable]: "Why doesn't it apply?",
		[DismissReasons.Incorrect]: 'What is incorrect?',
		[DismissReasons.Other]: 'Tell us more',
	},
	other: DismissReasons.Other,
};
